import { Component, Input } from '@angular/core';

import { AppConfig, ListReviewAndPublishMode } from '®shared/config';
import {
  Permissions,
  UserPermissions,
  hasPermissionForListId,
} from '®shared/permissions';
import {
  EditableList,
  ListPublishingState,
  ReadingListDetails,
} from '®shared/reading-list';

@Component({
  selector: 'rl-list-status-panel',
  templateUrl: './list-status-panel.component.html',
  styleUrls: ['./list-status-panel.component.scss'],
})
export class ListStatusPanelComponent {
  @Input() list: ReadingListDetails;
  @Input() editableList: EditableList;
  @Input() permissions: UserPermissions;
  @Input() listPublishingStatus: ListPublishingState;
  @Input() queueSize: number;

  private reviewWorkflow = this.appConfig.tenant.featureFlags.reviewWorkflow;

  constructor(private appConfig: AppConfig) {}

  get isReviewOnlyMode() {
    return this.reviewWorkflow === ListReviewAndPublishMode.REVIEW_ONLY;
  }

  get canViewReviewStatusForCurrentList() {
    return (
      this.hasActiveReview &&
      this.isReviewOnlyMode &&
      !this.canReviewCurrentList
    );
  }

  get hasActiveReview(): boolean {
    return Boolean(this.editableList && this.editableList.activeReviewUrl);
  }

  get canReviewCurrentList(): boolean {
    return hasPermissionForListId(
      Permissions.VIEW_ACQUISITIONS,
      this.editableList.id,
      this.permissions,
    );
  }
}
